import { createTheme } from '@mui/material'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    zero: true // custom breakpoint
    xxxs: true // custom breakpoint
    xxs: true // custom breakpoint
    xs: true
    sm: true
    md: true
    lg: true
    xl: true
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    error: React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    error?: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    error: true
  }
}

// Color palette - Clean & Modern Healthcare
export const colors = {
  tealBlue: '#007C91',
  skyCyan: '#4DD0E1',
  midnightSlate: '#263238',
  snowWhite: '#FFFFFF',
  accentCoral: '#FF7043',
} as const

let AppTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.tealBlue,
      contrastText: '#fff',
      light: colors.skyCyan,
    },
    secondary: {
      main: colors.accentCoral,
      contrastText: '#fff',
    },
    text: {
      primary: colors.midnightSlate,
      secondary: colors.tealBlue,
    },
    background: {
      default: '#F5F7FA',
      paper: colors.snowWhite,
    },
  },
  breakpoints: {
    values: {
      zero: 0,
      xxxs: 300,
      xxs: 390,
      xs: 425,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
})

// this section is for theme props that rely on palette or breakpoints defined above dynamically
AppTheme = createTheme(AppTheme, {
  typography: {
    error: {
      color: AppTheme.palette.error.main,
      fontWeight: 700,
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
  },
})

export default AppTheme
